export default function onEnter(e, func) {
    if (func === void 0) { func = function () { }; }
    if (e.key === "Enter") {
        func();
    }
}
